var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.25C8.5 3.58696 8.76339 2.95107 9.23223 2.48223C9.70107 2.01339 10.337 1.75 11 1.75C11.663 1.75 12.2989 2.01339 12.7678 2.48223C13.2366 2.95107 13.5 3.58696 13.5 4.25C14.9355 4.92878 16.1592 5.98541 17.0401 7.30662C17.9209 8.62784 18.4255 10.1638 18.5 11.75V15.5C18.5941 16.2771 18.8693 17.0213 19.3035 17.6727C19.7377 18.324 20.3188 18.8643 21 19.25H1C1.68117 18.8643 2.26226 18.324 2.69648 17.6727C3.13071 17.0213 3.40593 16.2771 3.5 15.5V11.75C3.57445 10.1638 4.07913 8.62784 4.95994 7.30662C5.84075 5.98541 7.06449 4.92878 8.5 4.25",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 19.25V20.5C7.25 21.4946 7.64509 22.4484 8.34835 23.1517C9.05161 23.8549 10.0054 24.25 11 24.25C11.9946 24.25 12.9484 23.8549 13.6517 23.1517C14.3549 22.4484 14.75 21.4946 14.75 20.5V19.25",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.afe1031e0e18f2f315e68fff8e63e4d1.svg";
export { ForwardRef as ReactComponent };